__turbopack_context__.v({
  "passport_faq_answer": "PassportFAQItem-module-scss-module__3nxtdG__passport_faq_answer",
  "passport_faq_app_logos": "PassportFAQItem-module-scss-module__3nxtdG__passport_faq_app_logos",
  "passport_faq_item": "PassportFAQItem-module-scss-module__3nxtdG__passport_faq_item",
  "passport_faq_question": "PassportFAQItem-module-scss-module__3nxtdG__passport_faq_question",
  "passport_faq_toggle_icon": "PassportFAQItem-module-scss-module__3nxtdG__passport_faq_toggle_icon",
});
